import React, { useState } from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Alert,
    CircularProgress,
    Tooltip
} from '@mui/material';
import {
    Delete as DeleteIcon,
    Warning as WarningIcon,
    CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import { headerData } from '../../../data/headerCostum';

export default function DeleteData({ id, endpoint }) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async () => {
        setLoading(true);
        
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}api/${endpoint}/${id}`,
                {
                    method: 'DELETE',
                    headers: headerData
                }
            );

            if (response.ok) {
                // Show success message
                await Swal.fire({
                    icon: 'success',
                    title: 'Berhasil!',
                    text: 'Data monitoring CCTV berhasil dihapus',
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'border-radius-lg'
                    }
                });

                // Reload page to refresh data
                window.location.reload();
            } else {
                throw new Error('Gagal menghapus data');
            }
        } catch (error) {
            console.error('Error deleting data:', error);
            
            // Show error message
            await Swal.fire({
                icon: 'error',
                title: 'Gagal!',
                text: 'Terjadi kesalahan saat menghapus data',
                confirmButtonColor: '#e91e63',
                customClass: {
                    popup: 'border-radius-lg'
                }
            });
        } finally {
            setLoading(false);
            handleClose();
        }
    };

    return (
        <>
            <Tooltip title="Hapus Data">
                <IconButton
                    size="small"
                    color="error"
                    onClick={handleClickOpen}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'error.light',
                            color: 'white'
                        }
                    }}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 1
                    }
                }}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <WarningIcon color="error" sx={{ mr: 1, fontSize: 28 }} />
                        <Typography variant="h6" fontWeight={600}>
                            Konfirmasi Hapus Data
                        </Typography>
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ pt: 2, pb: 3 }}>
                    <Alert 
                        severity="warning" 
                        sx={{ 
                            mb: 3,
                            borderRadius: 2,
                            '& .MuiAlert-message': {
                                width: '100%'
                            }
                        }}
                    >
                        <Typography variant="body1" fontWeight={600} sx={{ mb: 1 }}>
                            Peringatan!
                        </Typography>
                        <Typography variant="body2">
                            Tindakan ini tidak dapat dibatalkan. Data monitoring CCTV akan dihapus secara permanen dari sistem.
                        </Typography>
                    </Alert>

                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Apakah Anda yakin ingin menghapus data monitoring CCTV ini?
                    </Typography>

                    <Box 
                        sx={{ 
                            p: 2, 
                            backgroundColor: 'grey.50', 
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'grey.200'
                        }}
                    >
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            ID Data: <strong>{id}</strong>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Endpoint: <strong>{endpoint}</strong>
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ p: 3, pt: 0 }}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        disabled={loading}
                        sx={{
                            borderRadius: 2,
                            textTransform: 'none',
                            px: 3
                        }}
                    >
                        Batal
                    </Button>
                    <Button
                        onClick={handleDelete}
                        variant="contained"
                        color="error"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
                        sx={{
                            borderRadius: 2,
                            textTransform: 'none',
                            px: 3,
                            minWidth: 120
                        }}
                    >
                        {loading ? 'Menghapus...' : 'Hapus Data'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
